;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"065d0ae55699efe90ccb0398a5e64f3587016704"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';

import { SHARED_SENTRY_CONFIG } from './sentry.shared.config';

Sentry.init({
  ...SHARED_SENTRY_CONFIG,
});
